"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LayoutNotificationCriticality;
(function (LayoutNotificationCriticality) {
    LayoutNotificationCriticality["information"] = "information";
    LayoutNotificationCriticality["success"] = "success";
    LayoutNotificationCriticality["warning"] = "warning";
    LayoutNotificationCriticality["critical"] = "critical";
})(LayoutNotificationCriticality = exports.LayoutNotificationCriticality || (exports.LayoutNotificationCriticality = {}));
//# sourceMappingURL=models.js.map